module.exports = __webpack_public_path__ + "img/text.014965c2.png";